import React, { useEffect, useRef, useState } from 'react';
import { Button, message, Popconfirm, Spin } from 'antd';
import ReCAPTCHA from "react-google-recaptcha";

const Captcha = (
    {
        title,
        callBack
    }: {
        title: string,
        callBack: () => void
    }
) => {
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [nonClick, setNonClick] = useState(false);


    const handleRecaptchaChange = (value: any) => {
        setRecaptchaValue(value);
    };

    async function confirm () {
        setIsLoading(true);
        setNonClick(true);
        callBack()
        setRecaptchaValue(null);
        handleReset();
        setTimeout(() => {
            setIsLoading(false);
            setNonClick(false);
        }, 2000);
    };

    const cancel = () => {
        setRecaptchaValue(null);
        handleReset();
    };

    const handleReset = () => {
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
        }
    };

    return (
        <div>
            {/* Your form fields */}

            <Popconfirm
                title={title}
                // @ts-ignore
                description=<ReCAPTCHA ref={recaptchaRef} sitekey="6Lck6sYoAAAAAJiVHiepBv3tQn_rRJmE9ZCVLRUf" onChange={handleRecaptchaChange} />
                onConfirm={confirm}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ disabled: !recaptchaValue }}
            >
                <Button danger disabled={nonClick}>
                    {
                        isLoading ? <Spin /> : null
                    }
                    {title}
                </Button>
            </Popconfirm>
        </div>
    );
};

export default Captcha;